export default {
	dropDownList: '/iglobalwin-mail-api/admin/mail/config/drop-down/list', //账户管理设置默认邮箱-下拉列表
	addCustomer: '/customer', //新增客户
	editCustomer: '/customer', //编辑客户
	getCustomerList: '/customer/list', //客户列表
	getCustomerDetail: '/customer/{customerId}', //获取详情
	searchCustomer: '/customer/param_name', //客户模糊搜索
	getIndustry: '/sys/industry/param', // 客户行业
	foreigntrade: '/sys/industry/foreign', // 外贸行业
	addCustomerAccount: '/customer/account',
	editCustomerAccount: '/customer/account/{id}',
	toggleMsgStatus: '/customer/account/flag_msg/',
	getCustomerAccountList: '/customer/account/list/',
	deleteCustomerAccount: '/customer/account/',
	getCustomerAccount: '/customer/account/',
	getAddCustomerList: '/customer/temp/list', // 客户确认列表
	getCustomerAccountListDetail: '/customer/temp/', //获取客户信息
	getTempCustomer: '/customer/temp', //临时客户确认
	getOrderList: '/orders/temp/list', //客户订单列表
	getHaveCustomerList: '/orders/temp/have_list', // 已有客户订单列表
	getOrderListDeatail: '/orders/temp/', //客户订单详情
	getTempOrder: '/orders/temp', //临时订单确认
	getRenewalOrder: '/service/order/', //续单
	getCustomerpermissiondetail: '/customer/permissions/', // 客户模块权限详情
	setCustomerpermissiondetail: '/customer/permissions/', // 编辑客户模块权限详情
	getAppletAccess: '/service/flag_inform/', // 小程序访问权限
	orderlist: '/orders/list', // 订单列表
	servicedetail: '/service/{id}', // 服务单详情
	serviceEdit: '/service/{id}', // 服务单编辑
	updatelangeageNum: '/service/language_num/{id}', // 修改语种数量
	orderDetail: '/orders/{id}', // 订单详情
	orderDelete: '/orders/{id}', // 订单删除
	verificationcode: '/orders/sms/', // 获取验证码
	expirationtime: '/service/expiration_date/{id}', // 设置到期时间
	leaders: '/orders/leaders/', // 主管下拉
	domainname: '/service/sites/', // 网站域名列表
	emailvenify: '/customer/account/validation_email', // 验证邮箱
	edmResidueNum: '/service/edm/{id}', // edm剩余数量
	setCloudDiskNum: '/service/cloud-disk/{id}', // 设置云盘容量
	setAiReplyBotId: '/service/ai_reply/{id}', // AI自动回复配置botId
	setCompAnalysisNum: '/service/competitor_analysis/{id}', // 设置-竞争对手分析
	setAiCreativeNum: '/service/ai_creative/{id}', // 设置-AI创作
	visitors_to_identify: '/service/visitors_to_identify/{id}', //设置 - 访客识别
	monthdistinguishnum: '/visitor/monthdistinguishnum/{id}', //获取访客每月识别数

	createPersonMail: '/wy/email/createpersonalmailbox', //企业邮箱
	resetPassword: '/wy/email/updatepassword', //重置密码
	resultsReportList: '/ads/report/effect/push/list', // 成效报告列表
	reportDetail: '/ads/report/effect', // 成效报告
	resetEmail: '/customer/account/reset_email', //重置邮箱
	renewalRateChartData: '/service/renewal/chart', // 续费率图表
	downloadRenewalRate: '/customer/renewal/download', // 下载续费率报告
	rightControlList: '/service/permissions/list', // 权限控制列表
	setRightControl: '/service/permissions/{id}/enable', // 权限控制列表
	serviceLog: '/service/log/list', // 服务日志
	getPackagedropdownlist: '/admin/packages', // 套餐类型下拉
	defaultRoleList: '/iglobalwin-sso-api/role/selectrole', // 默认角色列表

	serviceTagList: '/service/tag/list', // 服务标签列表
	addServiceTag: '/service/{id}/tag', // 设置服务单标签

	setServiceSeo: '/service/seo/{id}', // SEO排名监控更新
	setSeoKeyWordNum: '/service/seo/keyword_num/{id}', // 设置-SEO关键词数量
	getServiceSeoDetail: '/service/seo/{id}', // SEO排名监控详情
	remainList: '/service/function-remain/list', // 服务单中智能网站访客识别查看日期和剩余数量
	editRemain: '/service/function-remain/function_num/{id}', // 编辑服务单中智能网站访客识别的剩余数量
	//国家地区
	countryList: '/geotargets/list', //todo跟换地区数据
};
